module.exports = __webpack_public_path__ + "static/media/Online popularity-amico.7b69b717.svg";